<template>
  <li class="list-group-item">
    <i aria-hidden="true" class="fa fa-trash pull-right" @click="removeObj(updateConditions, index)"></i>
    <collapse :selected="false">
      <div class="collapsible-header" slot="collapsible-header">
        {{ item.name }}
      </div>
      <div class="collapsible-body" slot="collapsible-body">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" v-model="item.name">
        </div>
        <div v-if="item.primaryState">
          <div class="states">
            <condition-builder
              :show-remove-btn="true"
              :state="item.primaryState"
              :schema="schema"
              :remove-obj="function( item ){return function() { item.primaryState = null }}(item)" />
          </div>
          <button class="btn green add-cond pull-right disabled">
            And
          </button>
          <div class="clearfix"></div>
        </div>
        <div v-for="(state, index) in item.states" class="states">
          <condition-builder :show-remove-btn="item.states.length > 1" :state="state" :schema="schema" :remove-obj="function(item, index){return function() { removeObj(item.states, index) }}(item, index)" />
        </div>
        <div class="btn-group pull-right">
          <button class="btn green add-cond"
                  v-if="!item.primaryState"
                  @click="setPrimaryAndAddUpdateState(item)">And
          </button>
          <button class="btn green add-cond" style="margin-left: 5px"
                  @click="addUpdateState(item.states)">Add
          </button>
        </div>
        <div class="clearfix"></div>
        <div class="form-group" v-show="item.states.length > 1">
          <label>If
            <select class="form-control"
                    style="width:70px; display:inline-block;"
                    v-model="item.all">
              <option value="false">Any</option>
              <option value="true">All</option>
            </select>
            the rules are matched</label>

        </div>
        <div v-for="(todo, index) in item.todo" class="states">
          <i aria-hidden="true" class="fa fa-trash pull-right"
             @click="removeObj(item.todo, index)"
             v-if="item.todo.length > 1"></i>
          <div class="form-group">
            <label>Do</label>
            <select class="form-control" v-model="todo.action">
              <option value="1">Update</option>
            </select>
          </div>
          <div class="form-group">
            <label>Field</label>
            <select class="form-control" v-model="todo.field">
              <option v-for="(field, index) in checkboxOnlySchema" :value="field.name"
                      :key="'show-field-' + index">
                <template v-if="field.depth === 1">&nbsp;-</template>
                <span>{{ field.label }}</span>
              </option>
            </select>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </collapse>
  </li>
</template>

<script>
import {updateFieldConditionPattern} from "@/utils/formBuilder/patterns";
import {FIELD_TYPE} from "../../../enums/fieldType";
import Collapse from '@/components/Collapse';
import { cloneDeep } from 'lodash'
import ConditionBuilder from "./ConditionBuilder";

export default {
  name: "UpdateFieldConditionConstructor",
  props: {
    updateConditions: Array,
    item: Object,
    index: Number,
    removeObj: Function,
    schema: Array,
    flatSchema: Array
  },
  components: {
    ConditionBuilder,
    Collapse
  },
  methods: {
    setPrimaryAndAddUpdateState(obj){
      obj.primaryState = cloneDeep(obj.states[0]);
      this.addUpdateState(obj.states)
      this.removeObj(this.item.states, 0)
    },
    addUpdateState(obj) {
      obj.push(JSON.parse(JSON.stringify(updateFieldConditionPattern.states[0])));
    },
  },
  computed: {
    checkboxOnlySchema(){
      return this.flatSchema.filter(schema => {
        return schema.type === FIELD_TYPE.CHECKBOX
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .states {
    border: 1px solid #ddd;
    padding: 20px;
  }
  .collapsible-body {
    padding: 1rem 2rem !important;
    width: 100%;
    background: #fff;
  }
  .add-cond {
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// UpdateFieldConditionConstructor.vue?0e5538da